import React, { Component } from "react";

export default class DefaultModal extends Component {
    render() {
        const { id, style, title, children, isVisible, styleContent } = this.props;
        return (
            <div
                className="modal modal-default fade in"
                id={id}
                style={{
                    display: isVisible ? "flex" : "none",
                    // paddingRight: "1.5rem",
                    ...style
                }}
            >
                <div className="modal-dialog modal-sm">
                    <div className="modal-content" style={{...styleContent, borderRadius: 10 }}>
                        <div className="modal-header" style={{ backgroundColor: "#113950" }}>
                            <h4 className="modal-title center-text" style={{ color: "white" }}>
                                {title}
                            </h4>
                        </div>
                        {children}
                    </div>
                </div>
            </div>
        );
    }
}

DefaultModal.defaultProps = {
    title: "Modal",
    id: "default-modal",
    children: <div>Olá Mundo</div>,
};
